import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Card, CardContent, CardHeader, Collapse, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { BuildingFloorForm } from './building-floor.form';
import { BuildingOtherForm } from './building-other.form';

interface BuildingFormProps {
  name?: string;
  index?: number;
  onRemove?: (index: number) => void;
  projectID?: string;
  syncWithDux: any;
  projectTypeValue?: any;
  existingData?: any;
}

export const BuildingForm = ({ name, index, onRemove, projectID, syncWithDux, projectTypeValue, existingData }: BuildingFormProps) => {
  const [expanded, setExpanded] = useState(true);
  const { control, getValues } = useFormContext();
  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: `${name}.buildingFloors`,
    keyName: 'fID',
  });

  const {
    fields: fieldsOther,
    append: appendOther,
    remove: removeOther,
  } = useFieldArray({
    control,
    name: `${name}.buildingCommonAreas`,
    keyName: 'oID',
  });

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleGenerateFloor = () => {
    const totalNumber = getValues(`${name}.floorsCount`);
    const buildings = [];
    for (let i = 0; i < totalNumber; i += 1) {
      buildings.push({ floorName: '' });
    }
    prepend(buildings);
  };

  const handleAddFloor = () => {
    append({ floorName: '' });
  };

  const handleRemoveFloor = (index: number) => {
    remove(index);
  };

  const handleAddOtherData = () => {
    appendOther({ other: '' });
  };

  const handleRemoveOtherData = (index: number) => {
    removeOther(index);
  };

  return (
    <Card elevation={0} className="buildingBlocks">
      <CardHeader
        className="subHead noPad"
        title={
          <Grid item lg={12} sm={12} xl={12} xs={12} className=" generateFloorContainer">
            {/* {index !== undefined && index >= 0 ? <div className="countRound">{index + 1}</div> : null} */}
            <div style={{ minWidth: '350px' }}>
              <FormInput name={`${name}.buildingName`} label="Building Name" />
            </div>
            <div style={{ flex: '1' }}>
              <FormInput name={`${name}.floorsCount`} label="No. of Floors" type="number" />
            </div>
            <div style={{ minWidth: '150px' }}>
              <Button
                className="btn  btn-primary"
                variant="outlined"
                sx={{ p: 1, m: 0, mr: 1 }}
                onClick={handleGenerateFloor}
              >
                GENERATE FLOOR
              </Button>
            </div>
            {onRemove && index && (
              <div style={{ marginLeft: 'auto' }}>
                <Button
                  className="btnTxtIconDelete"
                  variant="outlined"
                  sx={{ ms: 'auto' }}
                  aria-label="delete"
                  onClick={() => onRemove(index)}
                >
                  {'DELETE BUILDING'}

                  <Tooltip title={<Typography variant="body1">Delete</Typography>}>
                    <DeleteIcon className="btnDelete" />
                  </Tooltip>
                </Button>
              </div>
            )}
          </Grid>
        }
        action={
          <IconButton onClick={handleExpandClick}>{expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className="FUBlocksWrap ">
          <Grid container>
            <Grid item lg={12} sm={12} xl={12} xs={12} className="noPad">
              {fields?.map((field, index) => (
                <BuildingFloorForm
                  key={field.fID}
                  name={`${name}.buildingFloors.${index}`}
                  index={index}
                  onRemove={handleRemoveFloor}
                />
              ))}
              {fields?.length > 0 && (
                <div className="d-flex">
                  <Button
                    className="btnLink btn "
                    variant="outlined"
                    sx={{ p: 0.5, pl: 2, pr: 2, m: 0, mr: 1, ml: 'auto' }}
                    onClick={handleAddFloor}
                  >
                    Add New Floor
                  </Button>
                </div>
              )}
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12} className="noPad">
              {fieldsOther.map((field, index) => (
                <BuildingOtherForm
                  key={field.oID}
                  name={`${name}.buildingCommonAreas.${index}`}
                  index={index}
                  onRemove={handleRemoveOtherData}
                  projectID={projectID}
                  projectTypeValue={projectTypeValue}
                  syncWithDux={syncWithDux}
                  existingData={existingData}
                />
              ))}
              <Button
                className="  btn btn-primary"
                variant="outlined"
                sx={{ p: 1, m: 0, mr: 1, ml: 0, mt: 2 }}
                onClick={handleAddOtherData}
              >
                Add Other Details
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};
